export const environment = {
  production: false,
  API_URL: "https://staging-admin.tankerwashusa.com"
};



// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/environments/environment.ts